import $ from 'jquery';
import barba from '@barba/core';
import { gsap } from 'gsap';

import { disableBodyScroll, elementPosition, enableBodyScroll, lenis, replaceBodyClasses, scrollPosition, wait } from '../global/helpers';
import { $Elements, Events, Classes, Elements, Durations, BarbaLinks, resetAnimations, Breakpoints } from '../global/constants';

// ---------- Barba Initialisation ----------

barba.init({
	debug: false,
	preventRunning: true,
	prevent: ({ el }) => !$(el).is(BarbaLinks),
	transitions: [{
		sync: true,
		once: async() => $Elements.window.on('load', pageLoaded),
		enter: async() => $Elements.document.one(Events.page.transition, pageLoaded),
		leave: async(data) => {

			Elements.LoadingBar.classList.add(Classes.loading);
			document.body.classList.add(Classes.leaving);
			data.current.container.classList.add(Classes.leaving);

			if(isProjectLink(data)) {
				await projectTransition(data);
			}
			else {
				await defaultTransition(data);
			}

			return true;
		},
		after: async(data) => {

			lenis.scrollTo(0, { immediate: true });

			replaceBodyClasses(data.next);

			$('.' + Classes.transitionClone).remove();

			$Elements.document.trigger(Events.page.transition);

			return true;

		}
	}]
});

// ---------- Global ----------

async function pageLoaded() {

	resetAnimations();
	$Elements.document.trigger(Events.page.enter);
	Elements.MainWrapper.classList.remove(Classes.loading, Classes.initialLoad);
	Elements.LoadingBar.classList.remove(Classes.loading);
	Elements.LoadingOverlay.classList.remove(Classes.loading);

	return true;
}

// ---------- Default Transition ----------

async function defaultTransition(data) {

	Elements.LoadingOverlay.classList.add(Classes.loading);
	data.current.container.classList.add(Classes.leaving);

	const scroll = scrollPosition();
	data.current.container.style.top = -scroll.scrollTop + 'px';

	disableBodyScroll();
	lenis.scrollTo(0, { immediate: true });

	if(document.body.classList.contains(Classes.menuOpen)) {
		document.body.classList.remove(Classes.menuOpen);
	}

	await wait(Durations.page.ms);

	enableBodyScroll();

	return true;
}

// ---------- Project Transition ----------

function isProjectLink(data) {
	return (typeof data.trigger !== 'string' && data.trigger.classList.contains('project-link'));
}

async function projectTransition(data) {

	disableBodyScroll();
	data.current.container.classList.add(Classes.leaving);

	const link = data.trigger.parentNode.parentNode;
	const position = elementPosition(link);
	const scroll = scrollPosition();
	const nextProject = data.next.container.querySelector('.project-image-section .content');

	$(nextProject).empty();

	$(link).find('.project-image').each((i, image) => $(image).css({
		height: $(image).height(),
		width: $(image).width(),
	}));

	const clone = link;
	document.body.appendChild(clone);
	clone.classList.add(Classes.transitionClone);
	gsap.set(clone, { ...position });

	Elements.LoadingOverlay.classList.add(Classes.loading);

	const project = clone.querySelectorAll('.project, .project-inner');
	const projectImage = clone.querySelector('.project-image');
	const projectTitle = clone.querySelector('.project-title');

	await gsap.timeline({
		defaults: {
			duration: Durations.page.s / 1.5,
		}
	}).to(clone, {
		top: scroll.scrollTop,
		left: 0,
		width: window.innerWidth,
		height: window.innerHeight,
	}, 0).to(project, {
		x: 0, y: 0, z: 0,
		rotationX: 0, rotationY: 0, rotationZ: 0,
	}, 0).to(projectImage, {
		width: () => (window.innerWidth < Breakpoints.mobile) ? '80vmin' : '50vmin',
		height: () => (window.innerWidth < Breakpoints.mobile) ? '90vmin' : '60vmin',
	}, 0).to(projectTitle, {
		marginTop: '-7.5vh',
		fontSize: '100%',
	}, 0);

	resetAnimations();

	gsap.set(project, {
		x: 0, y: 0, z: 0,
		rotationX: 0, rotationY: 0, rotationZ: 0,
	});

	lenis.scrollTo(0, { immediate: true });

	gsap.set(clone, { top: 0 });
	gsap.set(data.current.container, { zIndex: -1 });

	document.body.classList.add('single-project');
	Elements.LoadingOverlay.classList.remove(Classes.loading);

	await wait(Durations.page.ms + 200);

	nextProject.appendChild(clone);
	clone.classList.remove(Classes.transitionClone);
	gsap.set(clone, { top: null, left: null, width: null, height: null });

	enableBodyScroll();

	return true;
}

